// extracted by mini-css-extract-plugin
module.exports = {"helpIcon":"#2388ff","successIcon":"#47ada4","warningIcon":"#f9a36c","errorIcon":"#d85a65","infoIcon":"#303e4c"};